import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { AUDIT_TRAIL_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetAuditTrailCardsDataProps {
  communityId: string,
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getAuditTrailCardsData = async (communityId: string, data: any) =>
  await axiosAuth.post(`${AUDIT_TRAIL_API(communityId)}/cards`, data);

const useGetAuditTrailCardsData = ({
  communityId,
  data,
  queryParams,
}: UseGetAuditTrailCardsDataProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["audit-trail-cards-data"],
    queryFn: () => getAuditTrailCardsData(communityId, data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetAuditTrailCardsData;
